export const fetchKoalaData = async (
  url,
  params,
  additionalOptions = {},
  {
    throwOnUnsuccessful = true
  } = {}) => {
  const verificationTokenHeaderName = 'X-XSRF-TOKEN'
  const tokenElements = document.getElementsByName(verificationTokenHeaderName)
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    ...additionalOptions,
    credentials: 'include',
    body: JSON.stringify(params)
  }

  if (tokenElements.length === 1) {
    options.headers[verificationTokenHeaderName] = tokenElements[0].value
  }

  try {
    const response = await fetch(url, options)

    if (response.status !== 200) throw new Error(`Failed with status ${response.status}`)

    const json = await response.json()
    const {
      success,
      data,
      errorMsg,
      errorMessage,
      errorCode,
      words
    } = json

    if (!success) {
      if (throwOnUnsuccessful) {
        const error = new Error(errorMsg || errorMessage || errorCode)

        if (data) error.data = data
        if (words) error.words = words

        throw error
      } else {
        return json
      }
    }

    if (!data) console.warn('No data returned.', json)

    return data || undefined
  } catch (error) {
    console.warn('Koala fetch failed')
    console.warn('1. Error:', error)
    console.warn('2. URL:', url)
    console.warn('3. params:', params)
    throw error
  }
}



// WEBPACK FOOTER //
// ./src/apis/koala.js